import { ShieldAlert } from 'lucide-react'
import { Card, EmptyState, PageHeader } from '@/components/ui'

export function DispoChefUebersichtPage() {
  return (
    <div className="p-6 space-y-6">
      <PageHeader
        title={
          <span className="flex items-center gap-2">
            <ShieldAlert className="w-6 h-6 text-brand-600" />
            Chef-Übersicht
          </span>
        }
        description="Kritische Tickets und fragwürdige Zeiteinträge"
      />
      <Card>
        <Card.Body>
          <EmptyState
            icon={<ShieldAlert className="w-8 h-8" />}
            title="Chef-Übersicht kommt bald"
            description="Diese Ansicht wird in einer zukünftigen Version verfügbar sein."
          />
        </Card.Body>
      </Card>
    </div>
  )
}
